import AuthService from '@/service/auth/auth.service'

const rutaFichero = process.env.VUE_APP_STORAGE_URL;
const rutaImg = process.env.VUE_APP_STORAGE_LOCAL_IMG;

const user = JSON.parse(localStorage.getItem('user'))

const initialState = user
    ? { status : { loggedIn : true }, user,        infoUser: [], roles: "", rutaFichero, rutaImg  }
    : { status : { loggedIn : false }, user: null,  infoUser: [], roles: "", rutaFichero, rutaImg  };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login ( {commit}, user) {
            return AuthService.login(user).then(
            (user) => {
                commit('loginSuccess', user);
                return Promise.resolve(user);
            }, (error) => {
                commit('loginFailure')
                return Promise.reject(error);
            });
        },
        // Resuelve con el usuario guardado o rechaza con `error.code` (ver AUTH_ERRORS).
        validateToken() {
            return AuthService.validateToken();
        },
        logout( {commit} ){
            AuthService.logout();
            commit('logout')
        },

        register( {commit}, user ){
            return AuthService.register(user).then(
            (response) => {
                commit('registerSuccess');
                return Promise.resolve(response.data);
            }, 
            (error) => {
                commit('registerFailure');
                return Promise.reject(error);
            });
        },
        setUser( {commit}, user ){
            commit('setUser', user );
        }
    },
    mutations: {
        loginSuccess(state, user){
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state){
            state.status.loggedIn = false;
            state.user = null;
            state.infoUser = [];
        },
        logout(state){
            state.status.loggedIn = false;
            state.user = null;
            // Sin esto, el siguiente login en la misma pestana heredaba los datos del anterior.
            state.infoUser = [];
        },
        registerSuccess(state){
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        setUser(state, user ){
            state.infoUser = user;
        }
    }
}
